<template>
  <Page current-link="contact">
    <div class="form col-center">
      <div class="title-sm">
        <img src="/heading-contact.png" alt="Contact Heading"/>
      </div>
      <p>
        If you’d like to leave a message, please feel free to send us an email.
      </p>
      <ContactForm/>
      <div class="foot-notes">
        <p>
          For a copy of our media kit and promotional images, please email us with reference to “Media”.
        </p>
        <p>
          For information regarding book sales, wholesale, and stockists, please email us with reference to “Sales”.
        </p>
      </div>
    </div>
  </Page>
</template>

<script setup lang="ts">

</script>

<style scoped>
  .foot-notes {
    margin-top: 36px;
  }
  .foot-notes p {
    text-align: center;
    margin: 0;
    padding: 0 0 8px 0;
  }
</style>
